/**
 * T6-B1: does this person belong at /audit-firm? True when they are staff of
 * a firm (accepted or invited) or hold an engagement seat. Errors (no firm
 * tier, unbound identity → 404) read as "no".
 */
import { req } from './api';

export async function hasFirmPresence(): Promise<boolean> {
  try {
    const mine = await req<{ firms?: unknown[]; pending_staff?: unknown[] }>('/api/audit-firms/mine');
    if ((mine.firms?.length ?? 0) > 0 || (mine.pending_staff?.length ?? 0) > 0) return true;
  } catch {
    /* not a firm member */
  }
  try {
    const seats = await req<{ engagements?: unknown[] }>('/api/audit-firms/engagements');
    return (seats.engagements?.length ?? 0) > 0;
  } catch {
    return false;
  }
}
